import React, { createContext, useState, useContext } from 'react';

const LoadingContext = createContext({
  isLoading: false,
  setLoading: (loading: boolean) => {}
});

interface LoadingProviderInterface{
    children: React.ReactNode
}

export const LoadingProvider: React.FC<LoadingProviderInterface> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <LoadingContext.Provider value={{ isLoading, setLoading: setIsLoading }}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);